import React from "react";
import { Helmet } from "react-helmet-async";
import { fullTitle as buildTitle, DEFAULT_DESCRIPTION, DEFAULT_IMAGE } from "../data/pageMeta";

export default function SEO({
  title,
  description,
  canonical,
  image,
  keywords = [],
  type = "website",
}) {
  const fullTitle = buildTitle(title);
  const desc = description || DEFAULT_DESCRIPTION;
  const url = canonical || (typeof window !== "undefined" ? window.location.href : "");
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(", ")} />
      )}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="fr_FR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      <meta name="robots" content="index, follow" />
      <html lang="fr" />
    </Helmet>
  );
}
